import { selectEnv } from './selectEnv'

export const env = selectEnv()
